import { Box, Grid, styled } from '@mui/material'
import { ReactNode } from 'react'
import { OperationLogInput } from '../../../../containers/common/operationLog'
import { GItem, RightGItem } from '../grids'
import { Link } from '../link'

interface UnitTitleProps {
  title: ReactNode
  linkTo?: string
  operationLog?: OperationLogInput
  hideLink?: boolean
}

const Root = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.font.sizeL1,
  letterSpacing: '0.2em',
  color: theme.palette.secondary.main,
  borderBottom: `1px solid ${theme.palette.secondary.main}`,
}))

export const UnitTitle = (props: UnitTitleProps) => {
  return(
    <>
      <Root>
        <Grid container direction={"row"} justifyContent={"space-between"}>
          <GItem xs={8}>{props.title}</GItem>
           <RightGItem xs={4}>
            {!props.hideLink && <Link
              to={props.linkTo}
              operationLog={props.operationLog}
            >
              編集
            </Link>}
          </RightGItem>
        </Grid>
      </Root>
    </>)
}
